import React, { useRef, useEffect, useState, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { Visibility } from '@material-ui/icons';

//import moment from 'moment';
import { ADM, GFE, GFO, GFU } from '~/constants/perfil';
import { UnidataTable } from '~/components';

import {
  operacaoAfericaoVeiculoInRequest,
  deleteOperacaoAfericaoVeiculo,
  findOperacaoAfericaoVeiculo,
  recordFiltering,
} from '~/store/modules/operacaoafericaoveiculo/actions';

import DetalheVeiculo from './components/DetalheVeiculo';

import OperacaoAfericaoVeiculoForm from './form';

import { number } from '~/helpers';

function OperacaoAfericaoVeiculo() {
  const dispatch = useDispatch();

  const { profile } = useSelector((state) => state.user);

  const [itemSelecionado, setItemSelecionado] = React.useState({});

  const [habEditarUsua, setHabEditarUsua] = useState(false);

  const [habEditar, setHabEditar] = useState(false);

  const listaVeiculosRef = useRef(null);

  const optionsSN = useMemo(
    () => [
      { value: 'Sim', label: 'Sim' },
      { value: 'Não', label: 'Não' },
    ],
    []
  );

  const buttons = [];

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      switch (profile.gloperfilid) {
        case GFE:
          setHabEditarUsua(false);
          break;
        case GFO:
        case GFU:
        case ADM:
          setHabEditarUsua(true);
          break;
        default:
          break;
      }
    }
    return function cleanup() {
      mounted = false;
    };
  }, [profile]);

  const operacaoafericaoveiculo = useSelector(
    (state) => state.operacaoafericaoveiculo
  );

  // async function handleUpdate() {
  //   await dispatch(recordFiltering(operacaoafericaoveiculo.params));
  // }

  const handleUpdate = React.useCallback(async () => {
    await dispatch(recordFiltering(operacaoafericaoveiculo.params));
  }, [operacaoafericaoveiculo.params]);

  // const initialDate = moment()
  //   .set({ hour: 0, minute: 0, second: 0 })
  //   .format('YYYY-MM-DDTHH:mm');

  // const finalDate = moment()
  //   .set({ hour: 23, minute: 59, second: 59 })
  //   .format('YYYY-MM-DDTHH:mm');

  const header = useMemo(
    () => [
      //const header = [
      {
        id: 'veic_placa_aux',
        label: 'Veículo',
        filter: {
          type: 'text',
        },
        align: 'left',
      },
      {
        id: 'orga_codigo',
        label: 'Cód Órgão',
        filter: {
          type: 'text',
        },
        align: 'left',
      },
      {
        id: 'unid_codigo',
        label: 'Cód Unidade',
        filter: {
          type: 'text',
        },
        align: 'left',
      },
      {
        id: 'veic_status',
        label: 'Status',
        filter: {
          type: 'text',
        },
        align: 'left',
      },
      {
        id: 'desc_veic_em_manutencao',
        label: 'Em Manutenção',
        align: 'left',
        formatted: (value) => optionsSN.find((o) => o.label === value).value,
        filter: {
          type: 'select',
          options: optionsSN,
        },
      },
      {
        id: 'desc_veic_em_afericao',
        label: 'Em Aferição',
        align: 'left',
        formatted: (value) => optionsSN.find((o) => o.label === value).value,
        filter: {
          type: 'select',
          options: optionsSN,
        },
      },
      {
        id: 'orga_nome',
        label: 'Desc Órgão',
        align: 'left',
      },
      {
        id: 'unid_nome',
        label: 'Desc Unidade',
        align: 'left',
      },
      {
        id: 'vemm_codigo',
        label: 'Cód Modelo',
        align: 'left',
      },
      {
        id: 'vemm_nome',
        label: 'Marca/Modelo',
        align: 'left',
      },
      {
        id: 'veic_ano_modelo',
        label: 'Ano Modelo',
        align: 'left',
      },
      {
        id: 'veic_ano_fabricacao',
        label: 'Ano Fabricação',
        align: 'left',
      },
      {
        id: 'veic_renavam',
        label: 'Renavam',
        align: 'left',
      },
      {
        id: 'veic_volume_tanque',
        label: 'Vol Tanque',
        align: 'right',
        formatted: (value) => number(value, 1),
      },
      {
        id: 'veic_totalizador',
        label: 'Totalizador',
        align: 'right',
        formatted: (value) => number(value, 1),
      },
      {
        id: 'veic_hodentrecadaconfirm',
        label: 'Hodômetro confirm.',
        align: 'left',
      },
      {
        id: 'veic_afericao_dvec',
        label: 'Aferição DVEC',
        align: 'left',
      },
      {
        id: 'vedv_contador_desc',
        label: 'Tipo DVEC',
        align: 'left',
      },
      {
        id: 'vedv_contador_permite',
        label: 'Permite incluir em aferição',
        align: 'left',
      },
      {
        id: 'desc_veic_possui_transp',
        label: 'Possui Transp',
        align: 'left',
      },
    ],
    []
  );

  const headerbuttons = useMemo(() => [
    buttons.push({
      title: 'Detalhe',
      action: (value) => listaVeiculosRef.current.handleToggleModal(value),
      icon: <Visibility />,
    }),
  ]);

  const registroSelecionado = React.useCallback(
    (values) => {
      setItemSelecionado(values);
    },
    [operacaoafericaoveiculo]
  );

  const habEditarbuttons = useMemo(() => {
    if (
      habEditarUsua &
      (itemSelecionado.vedv_contador_permite === 'PERMITE') &
      (itemSelecionado.veic_em_afericao === 'N')
    ) {
      setHabEditar(true);
    } else {
      setHabEditar(false);
    }
  }, [itemSelecionado, habEditarUsua]);

  return (
    <>
      <UnidataTable
        pdf
        excel
        reportOrder="veic_placa_aux ASC"
        title={'Aferição de Veículo'}
        create={false}
        delete={false}
        update={habEditar}
        //update={((habEditarUsua) & (itemSelecionado.vedv_contador_permite === 'PERMITE') & (itemSelecionado.veic_em_afericao === 'N'))?true:false}
        fixed
        header={header}
        form={OperacaoAfericaoVeiculoForm}
        find={findOperacaoAfericaoVeiculo}
        redux={operacaoafericaoveiculo}
        read={recordFiltering}
        actions={buttons}
        detach="veic_placa_aux"
        keys={['veic_placa']}
        onRow={(values) => registroSelecionado(values)}
        view="VW_VEICULO_VEIC_AFERICAO"
        reportTitle="Aferição Veículo"
      />

      {/* <Tabela
        noEdition={!habEditar}
        read={operacaoAfericaoVeiculoInRequest}
        remove={deleteOperacaoAfericaoVeiculo}
        state={operacaoafericaoveiculo}
        header={header}
        noCreate
        headerMobile="veic_placa_aux"
        unique={['veic_placa']}
        form={OperacaoAfericaoVeiculoForm}
        findItem={findOperacaoAfericaoVeiculo}
        recordFilter={recordFiltering}
        buttons={buttons}
        onCallback={(values) => registroSelecionado(values)}
      /> */}

      <DetalheVeiculo
        ref={listaVeiculosRef}
        update={() => handleUpdate()}
        name="detalhe"
      />
    </>
  );
}

export default OperacaoAfericaoVeiculo;
